/* Gommes d'électrolytes (04/10/2026, revu le 07/10 pour le Canada et le Royaume-Uni) — fiche : choix du lot, bouton, galerie, bouton collant mobile.
   Le formulaire est celui de Dawn (<product-form>, product-form.js) : on ne fait que changer la variante
   (et le plan d'abonnement s'il existe), le reste (ajout, tiroir) est le code d'origine.
   09/10/2026 (offre réglable) : chaque choix porte son nom (data-name) et, pour un abonnement, son plan de vente (data-gm-plan) ;
   un lien « ?selling_plan=… » ou un bouton data-gm-pick-plan choisit l'abonnement ; rien n'est calculé ici.
   11/10/2026 (grille A) : quand l'abonnement est choisi, le bouton dit « … — prix every month » et, dessous, « Cancel anytime » ;
   la barre collante dit le prix et, à gauche, sur 2 lignes, « Every month » puis « Cancel anytime ». Les deux textes viennent des réglages du thème.
   La barre collante sort dès que le bouton d'achat est dépassé : moins de 60 % à l'écran ET sorti par le haut (17/10 : plus jamais au chargement).
   11/10/2026 après-midi (prix barrés) : le bouton de la barre collante écrit, en petit sous le prix, le prix barré du choix (data-was,
   posé par snippets/gm-choice : c'est le prix barré que Shopify sert au pays de la visiteuse). Sans data-was, rien n'est barré. Rien n'est calculé ici.
   12/10/2026 (abonnement d'abord, décision d'Alex) : trois cartes, deux modes.
   - Mode par défaut : une carte qui porte un plan de vente (data-gm-plan, posé par snippets/gm-choice quand Shopify sert un plan pour sa
     variante) part au panier AVEC ce plan, au prix du plan ; une carte sans plan part en achat unique, au prix de la variante.
   - Mode « One time purchase » (lien souligné sous les logos de paiement) : 1 sachet choisi, JAMAIS de plan, les trois cartes montrent
     leur prix en une fois ; le lien devient « Back to refill … » et ramène le mode par défaut. Choisir une autre carte ne change pas de mode.
   - « Refill … / Stop or cancel anytime » n'est affiché que si ce qui part au panier porte un plan. Le bouton dit toujours « libellé — prix ».
   Les chiffres des deux modes sont posés par le thème sur chaque carte (data-price / data-was / data-per, data-once-…) : rien n'est calculé ici.
   28/10/2026 (bloc d'achat inspiré de 8hours, outputs/2026-10-28-unshaken-offre) : les cartes sont des LIGNES ; la ligne choisie montre deux coches dont la 1re dit le rythme RÉEL du plan,
   lot par lot (« 3 bags delivered every month · … », lu dans data-every, jamais écrit ici) ou, en achat unique, « One time purchase · no renewal » ; « One time purchase · prix » (au-dessus du
   bouton) GARDE le lot choisi au lieu de le remettre à 1 sachet ; un bouton « Back to refill … » dans la ligne choisie ramène l'abonnement ; sur téléphone la barre collante est visible
   dès le chargement et se cache tant que le bouton du bloc est à l'écran (sur ordinateur : comme avant, une fois le bouton dépassé). Rien n'est calculé ici : prix, barré, par jour viennent des data-* de la ligne.
   29/10/2026 (le bundle comme 8hours) : les cartes sont des cartes de formule ; leurs textes (abonnement / achat unique) sont écrits par le thème dans la page ; le script montre l'un ou l'autre (data-gm-once-state),
   garde le bloc d'achat et le dernier bloc d'offres d'accord, et le bouton de ce dernier envoie le même formulaire. */
(function () {
  function init(root) {
    if (!root || root.dataset.gmBound) return;
    root.dataset.gmBound = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-gm-data]').textContent); } catch (e) {}
    var idInput = root.querySelector('[data-gm-id]');
    var planInput = root.querySelector('[data-gm-plan-input]');
    var atc = root.querySelector('[data-gm-atc]');
    var atcLabel = root.querySelector('[data-gm-atc-label]');
    var atcSub = root.querySelector('[data-gm-atc-sub]');
    var line = root.querySelector('[data-gm-line]');
    var prelaunch = root.querySelector('[data-gm-prelaunch]');
    var sticky = root.querySelector('[data-gm-sticky]');
    var stickyBtn = root.querySelector('[data-gm-sticky-btn]');
    var stickyLabel = root.querySelector('[data-gm-sticky-label]');
    var stickyPack = root.querySelector('[data-gm-sticky-pack]');
    var stickyWas = root.querySelector('[data-gm-sticky-was]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('.gm-pack__radio'));
    /* 29/10/2026 (le bundle comme 8hours) : le dernier bloc d'offres (« Your move », section gm-offer) montre les MÊMES cartes ; les deux blocs restent d'accord : une carte choisie ici ou là est choisie
       partout, le mode « One-Time Purchase » aussi. Les textes des deux modes (abonnement / achat unique) sont écrits par le thème sur chaque carte ; le script ne fait que montrer l'un ou l'autre
       (attribut data-gm-once-state des deux blocs) : rien n'est calculé ni écrit ici.
       30/10/2026 (Alex) : « One-Time Purchase » ne vaut QUE pour 1 sachet, quelle que soit la formule choisie. L'appuyer sélectionne la variante « 1 bag » SANS plan de vente (le bouton, le formulaire et la barre
       collante disent le total d'un sachet) ; rechoisir une carte de formule (même la carte « 1 sachet », déjà cochée) revient à l'abonnement de CETTE formule ; « Back to subscription » (et un 2e appui sur la ligne)
       revient à l'abonnement qu'on avait avant. La carte « 1 sachet » est celle qui a le MOINS de sachets (data-bags) ; elle porte data-gm-single, ce qui lui fait dire l'achat unique pendant que les autres cartes
       gardent leur abonnement (assets/gm-v2.css). Même comportement dans « Your move ». */
    var mirrorEl = document.querySelector('[data-gm-offer-block]');
    var mirror = mirrorEl ? Array.prototype.slice.call(mirrorEl.querySelectorAll('.gm-pack__radio')) : [];
    var allRadios = radios.concat(mirror);
    var buyEls = [root.querySelector('.gm-buy')].concat(mirrorEl ? [mirrorEl] : []).filter(Boolean);
    var onceBtns = buyEls.map(function (el) { return el.querySelector('[data-gm-once]'); }).filter(Boolean);
    var ctaBtn = mirrorEl ? mirrorEl.querySelector('[data-gm-cta]') : null;
    var ctaLabel = mirrorEl ? mirrorEl.querySelector('[data-gm-cta-label]') : null;
    var once = false;   /* true = « One-Time Purchase » (1 sachet) : aucun plan de vente n'est envoyé */
    var lastSub = null; /* la carte d'abonnement choisie juste avant « One-Time Purchase » : « Back to subscription » y revient */
    function bagsOf(r) { return parseInt(r.dataset.bags, 10) || 0; }
    var single = radios.filter(function (x) { return bagsOf(x) > 0; }).sort(function (a, b) { return bagsOf(a) - bagsOf(b); })[0] || radios[0];
    allRadios.forEach(function (r) {
      var opt = r.closest('.gm-opt');
      if (opt && single && r.dataset.gmVariant === single.dataset.gmVariant) opt.setAttribute('data-gm-single', '');
    });
    var phone = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };   /* 28/10 : sur téléphone la barre collante se montre dès le chargement et se cache tant que le bouton du bloc est à l'écran */

    function every(radio) {
      var r = radio && radio.dataset.gmPlan ? radio : radios.filter(function (x) { return x.dataset.gmPlan; })[0];
      return (r && r.dataset.every) || data.everyFallback || 'every 4 weeks';
    }
    /* Ce qu'une carte vend dans le mode courant : le plan s'il y en a un et qu'on n'est pas en achat unique ; sinon la variante seule. */
    function offer(r) {
      var sub = !once && !!r.dataset.gmPlan;
      return { plan: sub ? r.dataset.gmPlan : '', price: sub ? r.dataset.price : r.dataset.oncePrice,
               was: sub ? r.dataset.was : r.dataset.onceWas, per: sub ? r.dataset.per : r.dataset.oncePer,
               wasLabel: sub ? (r.dataset.wasLabel || 'Regular price') : 'Regular price' };
    }
    function chosen() { return radios.filter(function (x) { return x.checked; })[0] || radios[0]; }

    function apply(radio) {
      if (!radio) return;
      if (once && single) radio = single;      /* l'achat unique ne vaut que pour 1 sachet */
      var vid = radio.dataset.gmVariant;
      allRadios.forEach(function (r) {
        var on = r.dataset.gmVariant === vid;
        r.checked = on;
        r.closest('.gm-pack').classList.toggle('is-selected', on);
        r.closest('.gm-opt').classList.toggle('is-open', on);
      });
      var main = radios.filter(function (x) { return x.dataset.gmVariant === vid; })[0] || radio;
      var o = offer(main);
      var plan = o.plan;
      idInput.value = vid;
      if (planInput) { planInput.value = plan; planInput.disabled = !plan; }
      var available = main.dataset.available === 'true';
      var label = (data.label || 'Add to cart') + ' | ' + o.price;
      atcLabel.textContent = label;
      atc.classList.remove('gm-atc--sub');
      if (atcSub) atcSub.hidden = true;
      var open = available && data.canShip;
      atc.disabled = !open;
      if (prelaunch) prelaunch.hidden = available || !data.canShip;
      if (line) line.textContent = main.dataset.sub || '';
      /* « One-Time Purchase | prix » : le prix d'1 SACHET, sans plan, quelle que soit la formule choisie ; soulignée quand elle est choisie ; le retour à l'abonnement est dans la carte choisie. */
      onceBtns.forEach(function (b) {
        b.textContent = (data.once || 'One-Time Purchase') + ' | ' + (single ? single.dataset.oncePrice : main.dataset.oncePrice);
        b.setAttribute('aria-pressed', once ? 'true' : 'false');
      });
      buyEls.forEach(function (el) { el.setAttribute('data-gm-once-state', once ? '1' : '0'); });
      root.classList.toggle('gm-main--once', once);
      if (ctaLabel) ctaLabel.textContent = label;
      if (ctaBtn) ctaBtn.disabled = !open;
      if (stickyLabel) stickyLabel.textContent = label;
      if (stickyBtn) stickyBtn.disabled = !open;
      /* Barre collante, à gauche : la formule choisie (« 3-Month Supply ») et, si elle part avec un plan, son rythme dessous (« Every 3 months ») ; la place manque pour plus. */
      var ev = every(main);
      if (stickyPack) stickyPack.textContent = (main.dataset.title || main.dataset.name || '') + (plan ? '\n' + ev.charAt(0).toUpperCase() + ev.slice(1) : '');
      if (stickyWas) {
        /* Le prix barré de ce qui part au panier, en petit sous le prix, dans le bouton de la barre. Sans prix barré : caché. */
        stickyWas.textContent = '';
        stickyWas.hidden = !o.was;
        if (o.was) {
          var wasLabel = document.createElement('span');
          wasLabel.className = 'visually-hidden';
          wasLabel.textContent = o.wasLabel + ' ';
          stickyWas.appendChild(wasLabel);
          stickyWas.appendChild(document.createTextNode(o.was));
        }
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', vid);
        url.searchParams.delete('selling_plan');
        url.searchParams.delete('once');
        window.history.replaceState({}, '', url.toString());
      }
    }
    /* Choisir une carte de formule = l'abonnement de cette formule. En achat unique la carte « 1 sachet » est déjà cochée : un clic dessus ne déclenche pas « change », d'où l'écoute du clic. */
    allRadios.forEach(function (r) {
      r.addEventListener('change', function () { once = false; apply(r); });
      r.addEventListener('click', function () { if (once) { once = false; apply(r); } });
    });
    /* « One-Time Purchase | prix » sélectionne la variante « 1 bag » sans plan ; un 2e appui, ou « Back to subscription » (dans la carte choisie), ramène l'abonnement d'avant. */
    onceBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (once) { once = false; apply(lastSub || chosen()); return; }
        lastSub = chosen();
        once = true;
        apply(single);
      });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-gm-back]') : null;
      if (!b) return;
      once = false;
      apply(lastSub || chosen());
    });
    /* Le bouton du dernier bloc d'offres envoie le MÊME formulaire que le bouton d'ici (une seule vente, un seul panier). */
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var form = atc.form;
        if (!atc.disabled && form && form.requestSubmit) form.requestSubmit(atc);
      });
    }
    /* 02/11/2026 : l'accueil envoie « ?variant=…&once=1 » quand « One-Time Purchase » y est choisi : la fiche l'ouvre en achat unique (1 sachet, sans plan). */
    if (/[?&]once=1(&|$)/.test(window.location.search) && single) { lastSub = chosen(); once = true; apply(single); } else { apply(chosen()); }

    /* 07/10 : les cartes « Pick your supply » plus bas dans la fiche (section gm-offer, boutons data-gm-pick) choisissent
       le lot dans le bloc d'achat et y remontent : un seul bouton d'achat, un seul prix affiché. */
    document.querySelectorAll('[data-gm-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = radios.filter(function (x) { return x.dataset.gmVariant === b.dataset.gmPick; })[0];   /* 12/10 : une carte par lot, le mode ne change pas */
        if (r) { r.checked = true; apply(r); }
        root.querySelector('.gm-buy').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* Bouton collant (17/10/2026, relecture de la fiche en entonnoir) : visible SEULEMENT une fois le vrai bouton dépassé, c'est-à-dire
       sorti par le HAUT de l'écran (moins de 60 % visible et son haut au-dessus de l'écran). Jamais au chargement, jamais par-dessus
       les cartes de prix (elles sont alors au-dessus de l'écran elles aussi) ; elle repart quand on remonte jusqu'au bouton.
       Avant le 17/10 : visible aussi quand le bouton n'était pas encore atteint (bas de l'écran) ; pour y revenir, retirer
       « && e.boundingClientRect.top < 0 » ci-dessous.
       28/10/2026 (bloc d'achat inspiré de 8hours) : sur téléphone et tablette (jusqu'à 989 px) la barre est visible DÈS LE CHARGEMENT (le lot choisi, son prix, le bouton ; pas de liste des lots), se CACHE tant
       que le bouton du bloc d'achat est à l'écran (même un bout) et REVIENT dès qu'il sort, au-dessus comme en dessous : jamais deux boutons identiques à la fois ; la règle ci-dessus ne vaut plus que
       sur ordinateur.
       29/10/2026 (le bundle, 2e passe) : sur téléphone la barre n'est plus là au chargement : elle n'apparaît qu'une fois la RANGÉE D'ICÔNES du haut de la fiche sortie de l'écran par le haut (le 1er écran
       montre les 4 icônes et leurs libellés en entier), reste cachée tant que le bouton du bloc d'achat est à l'écran (même un bout) et revient quand il est dépassé. Sans rangée d'icônes (réglage
       éteint) : la règle du 28/10 (visible quand le bouton du bloc est hors de l'écran). */
    var iconRow = root.querySelector('.gm-benefits');
    function stickyShould() {
      var r = atc ? atc.getBoundingClientRect() : null;
      if (!r) return false;
      var seen = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
      if (phone.matches) {
        var rowGone = !iconRow || iconRow.getBoundingClientRect().bottom <= 0;
        return rowGone && !(r.height > 0 && seen > 0);
      }
      return r.height > 0 && seen / r.height < 0.6 && r.top < 0;
    }
    if (sticky && atc && 'IntersectionObserver' in window) {
      var stickyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var passed = stickyShould();
          sticky.classList.toggle('is-visible', passed);
          sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = passed ? 0 : -1;
        });
      }, { threshold: [0, 0.6, 1] });
      stickyIO.observe(atc);
      if (iconRow) stickyIO.observe(iconRow);
    }
    /* 27/10/2026 (page produit v2) : un saut direct du bas de la page vers le haut (retour en haut, lien d'ancre) ne fait jamais traverser l'écran au bouton, qui est
       sous le 1er écran : l'observateur ne se déclenche pas et la barre restait affichée en haut de page. On refait donc la MÊME mesure (moins de 60 % visible ET haut
       au-dessus de l'écran) à chaque défilement (une fois par image) et au redimensionnement. */
    if (sticky && atc) {
      var stickyTick = false;
      var stickyMeasure = function () {
        stickyTick = false;
        var passed = stickyShould();
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = passed ? 0 : -1;
      };
      var stickyOnScroll = function () { if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(stickyMeasure); } };
      window.addEventListener('scroll', stickyOnScroll, { passive: true });
      window.addEventListener('resize', stickyOnScroll);
      if (phone.addEventListener) phone.addEventListener('change', stickyOnScroll);
      stickyMeasure();
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = atc.form;
        if (!atc.disabled && form && form.requestSubmit) { form.requestSubmit(atc); return; }
        root.querySelector('.gm-buy').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* Galerie : défilement natif (scroll-snap), compteur, flèches, points.
       05/10 galerie D1 : sur téléphone les photos sont des carrés plus étroits que la bande (le suivant dépasse) :
       la diapositive courante est la plus proche de la position de défilement, et la dernière quand on est au bout. */
    var track = root.querySelector('[data-gm-track]');
    if (track) {
      var slides = track.querySelectorAll('[data-gm-slide]');
      var count = root.querySelector('[data-gm-count]');
      var dots = root.querySelectorAll('[data-gm-dot]');
      var current = 0;
      function pos(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
      function at() {
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return slides.length - 1;
        var best = 0, gap = Infinity;
        for (var k = 0; k < slides.length; k++) {
          var d = Math.abs(pos(k) - track.scrollLeft);
          if (d < gap) { gap = d; best = k; }
        }
        return best;
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: pos(i), behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        var i = at();
        if (i === current) return;
        current = i;
        if (count) count.textContent = String(i + 1);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
      var prev = root.querySelector('[data-gm-prev]');
      var next = root.querySelector('[data-gm-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      });

      /* Visionneuse (05/10 galerie D1) : <dialog> natif (focus piégé, Échap), page figée derrière, retour à la photo vue. */
      var viewer = root.querySelector('[data-gm-viewer]');
      if (viewer && typeof viewer.showModal === 'function') {
        var vtrack = viewer.querySelector('[data-gm-vtrack]');
        var vcount = viewer.querySelector('[data-gm-vcount]');
        var vn = vtrack.children.length, vcur = 0, opener = null;
        var zooms = root.querySelectorAll('[data-gm-zoom]');
        function vset(i) { vcur = i; if (vcount) vcount.textContent = String(i + 1); }
        function vgo(i) {
          i = Math.max(0, Math.min(vn - 1, i));
          vtrack.scrollTo({ left: i * vtrack.clientWidth, behavior: 'smooth' });
        }
        vtrack.addEventListener('scroll', function () {
          var i = Math.round(vtrack.scrollLeft / Math.max(1, vtrack.clientWidth));
          if (i !== vcur) vset(i);
        }, { passive: true });
        zooms.forEach(function (b) {
          b.addEventListener('click', function () {
            opener = b;
            var i = parseInt(b.dataset.gmZoom, 10) || 0;
            document.documentElement.classList.add('gm-lock');
            viewer.showModal();
            vtrack.scrollLeft = i * vtrack.clientWidth;
            vset(i);
          });
        });
        viewer.addEventListener('close', function () {
          document.documentElement.classList.remove('gm-lock');
          var b = zooms[vcur];
          if (b) {
            var s = b.closest('[data-gm-slide]');
            var k = Array.prototype.indexOf.call(slides, s);
            if (k >= 0) track.scrollLeft = pos(k);
          }
          var f = b || opener;
          if (f) f.focus({ preventScroll: true });
        });
        var vclose = viewer.querySelector('[data-gm-vclose]');
        var vprev = viewer.querySelector('[data-gm-vprev]');
        var vnext = viewer.querySelector('[data-gm-vnext]');
        if (vclose) vclose.addEventListener('click', function () { viewer.close(); });
        if (vprev) vprev.addEventListener('click', function () { vgo(vcur - 1); });
        if (vnext) vnext.addEventListener('click', function () { vgo(vcur + 1); });
        viewer.addEventListener('click', function (e) {
          if (e.target === viewer || e.target.classList.contains('gm-zoom__slide')) viewer.close();
        });
        viewer.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); vgo(vcur - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); vgo(vcur + 1); }
        });
      }
    }
  }

  /* Visuels dessinés : si le contenu dépasse la diapositive (galerie basse sur petit téléphone), on le réduit. */
  function fitAll() {
    document.querySelectorAll('.gm-info').forEach(function (box) {
      var fit = box.querySelector('.gm-fit');
      if (!fit) return;
      fit.style.transform = '';
      var cs = getComputedStyle(box);
      var h = box.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      var w = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var s = Math.min(1, h / Math.max(1, fit.scrollHeight), w / Math.max(1, fit.scrollWidth));
      if (s < 1) fit.style.transform = 'scale(' + s.toFixed(3) + ')';
    });
  }

  function boot() { document.querySelectorAll('[data-gm-main]').forEach(init); fitAll(); }
  window.addEventListener('resize', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
